import React from 'react';
import { IAppRouteConfig } from './type/approute';

const appsRoute: IAppRouteConfig[] = [
  {
    key: 'appsProject.admin-dashboard',
    path: `/admin`,
    component: React.lazy(
      () => import('../../components/Admin/Admin-dashboard')
    ),
    authority: ['access_admin_panel'],
  },
  {
    key: 'appsProject.user-list',
    path: `/user-list/:param`,
    component: React.lazy(
      () => import('../../components/template/User-Table/User-table')
    ),
  },
  {
    key: 'appsProject.dashboard',
    path: `/about`,
    component: React.lazy(() => import('../../view/about/About')),
  },
  // {
  //   key: 'appsProject.report',
  //   path: `/report`,
  //   component: React.lazy(
  //     () => import('../../view/report-page/static-reports/ReportPage')
  //   ),
  // },
  {
    key: 'appsProject.daktarbhai',
    path: `/daktarbhai`,
    component: React.lazy(
      () =>
        import('../../view/report-page/static-reports/daktarbhai/daktarbhai')
    ),
  },
  {
    key: 'appsProject.attendance',
    path: `/attendance`,
    component: React.lazy(
      () =>
        import(
          '../../view/report-page/dynamic-reports/attendance/AttendanceReport'
        )
    ),
  },
  {
    key: 'appsProject.incomeTaxStatement',
    path: `/income-taxstatement`,
    component: React.lazy(
      () =>
        import(
          '../../view/report-page/dynamic-reports/income-tax-statement/IncomeTaxStatement'
        )
    ),
  },

  {
    key: 'appsProject.leave-record',
    path: `/leave-record`,
    component: React.lazy(
      () =>
        import(
          '../../view/report-page/dynamic-reports/leave-records/LeaveRecordsReport'
        )
    ),
  },
  {
    key: 'appsProject.leave-encashment',
    path: `/leave-encashment`,
    component: React.lazy(
      () =>
        import(
          '../../view/report-page/dynamic-reports/leave-encashment-bill/LeaveEncashmentBillReport'
        )
    ),
  },
  {
    key: 'appsProject.transport-bill',
    path: `/transport-bill`,
    component: React.lazy(
      () =>
        import(
          '../../view/report-page/dynamic-reports/transport-bill/TransportBillReport'
        )
    ),
  },
  {
    key: 'appsProject.bonusSlip',
    path: `/bonus-slip`,
    component: React.lazy(
      () =>
        import(
          '../../view/report-page/dynamic-reports/bonus-slip/BonusSlipReport'
        )
    ),
  },
  {
    key: 'appsProject.otherReports',
    path: `/otherReports`,
    component: React.lazy(
      () =>
        import(
          '../../view/report-page/dynamic-reports/attendance/AttendanceReport'
        )
    ),
  },
  {
    key: 'appsProject.pay-slip',
    path: `/pay-slip`,
    component: React.lazy(
      () =>
        import('../../view/report-page/dynamic-reports/pay-slip/PaySlipReport')
    ),
  },
  {
    key: 'appsProject.provident-fund',
    path: `/provident-fund`,
    component: React.lazy(
      () =>
        import(
          '../../view/report-page/dynamic-reports/provident-fund/ProvidentFund'
        )
    ),
  },
  {
    key: 'appsProject.otherReports',
    path: `/loan-certificate`,
    component: React.lazy(
      () =>
        import(
          '../../view/report-page/dynamic-reports/loan-certificate/LoanCertificateReport'
        )
    ),
  },
  {
    key: 'appsProject.SalaryReviewAdjustment',
    path: `/salary-review-adjustment`,
    component: React.lazy(
      () =>
        import(
          '../../view/report-page/static-reports/salary-review-adjustment/SalaryReviewAdjustment'
        )
    ),
  },
  {
    key: 'appsProject.DesignationChange',
    path: `/designation-change`,
    component: React.lazy(
      () =>
        import(
          '../../view/report-page/static-reports/new-salary-promotion/DesignationChange'
        )
    ),
  },
  {
    key: 'appsProject.NewSalaryPromotion',
    path: `/promotion-letter`,
    component: React.lazy(
      () =>
        import(
          '../../view/report-page/static-reports/new-salary-promotion/NewSalaryPromotion'
        )
    ),
  },
  {
    key: 'appsProject.OneOffBonus',
    path: `/one-off-bonus`,
    component: React.lazy(
      () =>
        import(
          '../../view/report-page/static-reports/new-salary-promotion/OneOffBonus'
        )
    ),
  },
  {
    key: 'appsProject.PerformanceBonus',
    path: `/performance-bonus`,
    component: React.lazy(
      () =>
        import(
          '../../view/report-page/static-reports/new-salary-promotion/PerformanceBonus'
        )
    ),
  },
  {
    key: 'appsProject.AppreciationLetter',
    path: `/appreciation-letter`,
    component: React.lazy(
      () =>
        import(
          '../../view/report-page/static-reports/new-salary-promotion/AppreciationLetter'
        )
    ),
  },
  {
    key: 'appsProject.TaxCertificate',
    path: `/tax-certificate`,
    component: React.lazy(
      () =>
        import(
          '../../view/report-page/static-reports/tax-certificate/TaxCertificate'
        )
    ),
  },
  {
    key: 'appsProject.TaxAcknowledgement',
    path: `/tax-acknowledgement`,
    component: React.lazy(
      () =>
        import(
          '../../view/report-page/static-reports/tax-acknowledgement/TaxAcknowledgement'
        )
    ),
  },
  {
    key: 'appsProject.TaxReturnPaper',
    path: `/tax-return-paper`,
    component: React.lazy(
      () =>
        import(
          '../../view/report-page/static-reports/tax-return-paper/TaxReturnPaper'
        )
    ),
  },
  {
    key: 'appsProject.HealthInsurance',
    path: `/health-insurance`,
    component: React.lazy(
      () =>
        import(
          '../../view/report-page/static-reports/health-insurance/HealthInsurance'
        )
    ),
  },
  {
    key: 'appsProject.HealthReport',
    path: `/health-report`,
    component: React.lazy(
      () =>
        import(
          '../../view/report-page/static-reports/health-report/HealthReport'
        )
    ),
  },
  {
    key: 'appsProject.NomineeProfile',
    path: `/nominee-profile`,
    component: React.lazy(
      () =>
        import(
          '../../view/report-page/static-reports/nominee-profile/NomineeProfile'
        )
    ),
  },
  {
    key: 'appsProject.LoanStatus',
    path: `/loan-status`,
    component: React.lazy(
      () =>
        import(
          '../../view/report-page/dynamic-reports/loan-status/LoanStatusReport'
        )
    ),
  },
  {
    key: 'appsProject.dps',
    path: `/dps`,
    component: React.lazy(
      () => import('../../view/report-page/dynamic-reports/dps/DpsReport')
    ),
  },
  {
    key: 'appsProject.bblDocs',
    path: `/bbl-docs`,
    component: React.lazy(
      () => import('../../view/report-page/static-reports/bbl-docs/bblDocs')
    ),
  },
  {
    key: 'appsProject.hrFormats',
    path: `/hr-formats`,
    component: React.lazy(
      () => import('../../view/report-page/static-reports/hr-formats/hrFormats')
    ),
  },
  {
    key: 'appsProject.guidelines',
    path: `/guidelines-and-policies`,
    component: React.lazy(
      () =>
        import(
          '../../view/report-page/static-reports/guideline-policies/guidelinesPolicies'
        )
    ),
  },
  {
    key: 'appsProject.guidelines',
    path: `/circulars`,
    component: React.lazy(
      () => import('../../view/report-page/static-reports/circulars/circular')
    ),
  },
  {
    key: 'appsProject.dashboard',
    path: `/`,
    component: React.lazy(() => import('../../view/dashboard/Dashboard')),
  },
  {
    key: 'adminProject.secondaryLogo',
    path: `/admin/secondary-logo`,
    component: React.lazy(
      () => import('../../components/Admin/Secondary-Image/SecondaryImageList')
    ),
    authority: ['view_secondarylogo'],
  },

  {
    key: 'adminProject.secondaryLogoUpload',
    path: `/admin/secondary-logo/upload`,
    component: React.lazy(
      () => import('../../components/Admin/Secondary-Image/SecondaryImageForm')
    ),
    authority: ['add_secondarylogo'],
  },
  {
    key: 'adminProject.secondaryLogoUpload',
    path: `/admin/file-list/upload`,
    component: React.lazy(
      () => import('../../components/Admin/File-upload/FileUpload')
    ),
    authority: ['add_document'],
  },
  {
    key: 'adminProject.secondaryLogoUpload',
    path: `/admin/ack-report`,
    component: React.lazy(
      () => import('../../components/Admin/Acknowledge-log/ackReport')
    ),
    authority: ['view_documentack'],
  },
  {
    key: 'adminProject.secondaryLogoUpload',
    path: `/admin/file-list`,
    component: React.lazy(
      () => import('../../components/Admin/File-upload/FileList')
    ),
    authority: ['view_document'],
  },
  {
    key: 'adminProject.secondaryLogoEdit',
    path: `/admin/secondary-logo/edit/:id`,
    component: React.lazy(
      () => import('../../components/Admin/Secondary-Image/SecondaryImageForm')
    ),
    authority: ['change_secondarylogo'],
  },
  {
    key: 'adminProject.DocumentEdit',
    path: `/admin/file-list/edit/:id`,
    component: React.lazy(
      () => import('../../components/Admin/File-upload/FileUpdate')
    ),
    authority: ['change_document'],
  },
  {
    key: 'adminProject.banner',
    path: `/admin/banner`,
    component: React.lazy(
      () => import('../../components/Admin/Banner-Image/BannerImageList')
    ),
    authority: ['view_banner'],
  },
  {
    key: 'adminProject.audit',
    path: `/admin/audit`,
    component: React.lazy(() => import('../../view/auditLog/Audit')),
    authority: ['view_logentry'],
  },
  {
    key: 'adminProject.taxCard',
    path: `/admin/tax-card`,
    component: React.lazy(
      () => import('../../components/Admin/Tax-Card/tax-card')
    ),
    authority: ['change_taxrebate', 'view_taxrebate'],
  },
  {
    key: 'adminProject.bannerUpload',
    path: `/admin/banner/upload`,
    component: React.lazy(
      () => import('../../components/Admin/Banner-Image/BannerImageForm')
    ),
    authority: ['add_banner'],
  },
  {
    key: 'adminProject.bannerEdit',
    path: `/admin/banner/edit/:id`,
    component: React.lazy(
      () => import('../../components/Admin/Banner-Image/BannerImageForm')
    ),
    authority: ['change_banner'],
  },
  {
    key: 'adminProject.carousel',
    path: `admin/carousel`,
    component: React.lazy(
      () => import('../../components/Admin/Carousel-Image/CarouselImageList')
    ),
    authority: ['view_dashboardslider'],
  },

  {
    key: 'adminProject.carouselUpload',
    path: `admin/carousel/upload`,
    component: React.lazy(
      () => import('../../components/Admin/Carousel-Image/CarouselImageForm')
    ),
    authority: ['add_dashboardslider'],
  },
  {
    key: 'adminProject.carouselEdit',
    path: `admin/carousel/edit/:id`,
    component: React.lazy(
      () => import('../../components/Admin/Carousel-Image/CarouselImageForm')
    ),
    authority: ['change_dashboardslider'],
  },
  {
    key: 'adminProject.facts',
    path: `admin/facts`,
    component: React.lazy(
      () => import('../../components/Admin/Did-u-know/FactList')
    ),
    authority: ['view_fact'],
  },
  {
    key: 'adminProject.factCard',
    path: `admin/fact-card`,
    component: React.lazy(
      () => import('../../components/Admin/Did-u-know/FactCardForm')
    ),
    authority: ['add_factcard', 'change_factcard'],
  },
  {
    key: 'adminProject.userPermission',
    path: `admin/userPermission`,
    component: React.lazy(
      () => import('../../components/Admin/Permissions/UserPermission')
    ),
    authority: ['view_user'],
  },
  {
    key: 'adminProject.userPermissionGroup',
    path: `admin/userPermissionGroup`,
    component: React.lazy(
      () => import('../../components/Admin/Permissions/UserPermissionGroup')
    ),
    authority: ['view_permissiongroup'],
  },
  {
    key: 'adminProject.userPermissionNew',
    path: `admin/userPermission/new`,
    component: React.lazy(
      () => import('../../components/Admin/Permissions/UserPermissionForm')
    ),
    authority: ['change_user_group'],
  },
  {
    key: 'adminProject.userPermissionGroupNew',
    path: `/admin/userPermissionGroup/new`,
    component: React.lazy(
      () => import('../../components/Admin/Permissions/UserPermissionGroupForm')
    ),
    authority: ['add_permissiongroup'],
  },
  {
    key: 'adminProject.userPermissionEdit',
    path: `/admin/userPermission/edit/:id`,
    component: React.lazy(
      () => import('../../components/Admin/Permissions/UserPermissionForm')
    ),
    authority: ['change_user_group'],
  },
  {
    key: 'adminProject.userPermissionGroupEdit',
    path: `/admin/userPermissionGroup/edit/:id`,
    component: React.lazy(
      () => import('../../components/Admin/Permissions/UserPermissionGroupForm')
    ),
    authority: ['change_permissiongroup'],
  },

  {
    key: 'adminProject.factsUpload',
    path: `admin/facts/upload`,
    component: React.lazy(
      () => import('../../components/Admin/Did-u-know/FactForm')
    ),
    authority: ['add_fact'],
  },
  {
    key: 'adminProject.factsEdit',
    path: `admin/facts/edit/:id`,
    component: React.lazy(
      () => import('../../components/Admin/Did-u-know/FactForm')
    ),
    authority: ['change_fact'],
  },
  {
    key: 'adminProject.events',
    path: `admin/events`,
    component: React.lazy(
      () => import('../../components/Admin/Event/EventList')
    ),
    authority: ['view_event'],
  },
  /** start error page url
   * all error page URLs must follow this convention eg: /error-someting-url */
  {
    key: 'adminProject.errors',
    path: `/error-not-found`,
    component: React.lazy(() => import('../../components/Errors/error404')),
  },
  {
    key: 'adminProject.errors',
    path: `/error-forbidden`,
    component: React.lazy(() => import('../../components/Errors/error403')),
  },
  {
    key: 'adminProject.errors',
    path: `/error-502`,
    component: React.lazy(() => import('../../components/Errors/error502')),
  },
  {
    key: 'adminProject.errors',
    path: `/error-505`,
    component: React.lazy(() => import('../../components/Errors/error505')),
  },
  /** end error page url */
  {
    key: 'adminProject.eventUpload',
    path: `admin/events/upload`,
    component: React.lazy(
      () => import('../../components/Admin/Event/EventForm')
    ),
    authority: ['add_event'],
  },
  {
    key: 'adminProject.eventEdit',
    path: `admin/events/edit/:id`,
    component: React.lazy(
      () => import('../../components/Admin/Event/EventForm')
    ),
    authority: ['change_event'],
  },
  {
    key: 'adminProject.menu',
    path: `admin/menu`,
    component: React.lazy(() => import('../../components/Admin/Menu/MenuList')),
    authority: ['view_menuitem'],
  },
  {
    key: 'adminProject.menu',
    path: `admin/menu/edit/:id`,
    component: React.lazy(() => import('../../components/Admin/Menu/MenuForm')),
    authority: ['change_menuitem'],
  },
  {
    key: 'adminProject.menu',
    path: `/admin/menu/add-new`,
    component: React.lazy(() => import('../../components/Admin/Menu/MenuForm')),
    authority: ['add_menuitem'],
  },
  {
    key: 'adminProject.submenu',
    path: `admin/sub-menu`,
    component: React.lazy(
      () => import('../../components/Admin/Menu/MenuItemList')
    ),
    authority: ['view_submenuitem'],
  },
  {
    key: 'adminProject.newMenu',
    path: `admin/sub-menu/edit/:id`,
    component: React.lazy(
      () => import('../../components/Admin/Menu/MenuItemForm')
    ),
    authority: ['change_submenuitem'],
  },
  {
    key: 'adminProject.newMenu',
    path: `admin/sub-menu/upload`,
    component: React.lazy(
      () => import('../../components/Admin/Menu/MenuItemForm')
    ),
    authority: ['add_submenuitem'],
  },
  {
    key: 'adminProject.newsCarousel',
    path: `/admin/news-carousel`,
    component: React.lazy(
      () => import('../../components/Admin/News-carousel/NewsCarousel')
    ),
    authority: ['view_notice'],
  },
  {
    key: 'adminProject.menuEdit',
    path: `admin/menu/edit/:id`,
    component: React.lazy(() => import('../../components/Admin/Menu/MenuForm')),
    authority: ['change_menu'],
  },
  {
    key: 'adminProject.menuEdit',
    path: `admin/menu/upload`,
    component: React.lazy(() => import('../../components/Admin/Menu/MenuForm')),
    authority: ['add_menu'],
  },
  {
    key: 'adminProject.newsCarousel',
    path: `/admin/news-carousel/add-new`,
    component: React.lazy(
      () => import('../../components/Admin/News-carousel/NewsForm')
    ),
    authority: ['add_notice'],
  },
  {
    key: 'adminProject.newsCarousel',
    path: `/admin/news-carousel/edit/:id`,
    component: React.lazy(
      () => import('../../components/Admin/News-carousel/NewsForm')
    ),
    authority: ['change_notice'],
  },
  {
    key: 'adminProject.importantContacts',
    path: `/admin/important-contacts`,
    component: React.lazy(
      () =>
        import(
          '../../components/Admin/Important-contacts/ImportantContactsList'
        )
    ),
    authority: ['add_contact', 'change_contact', 'delete_contact'],
  },
  {
    key: 'adminProject.importantContacts',
    path: `/admin/important-contacts/add-new`,
    component: React.lazy(
      () =>
        import(
          '../../components/Admin/Important-contacts/ImportantContactsForm'
        )
    ),
    authority: ['add_contact'],
  },
  {
    key: 'adminProject.importantContacts',
    path: `/admin/important-contacts/edit/:id`,
    component: React.lazy(
      () =>
        import(
          '../../components/Admin/Important-contacts/ImportantContactsForm'
        )
    ),
    authority: ['change_contact'],
  },
  {
    key: 'adminProject.importantContacts',
    path: `/admin/footer-links`,
    component: React.lazy(
      () => import('../../components/Admin/Footer-Links/FooterLinksList')
    ),
    authority: ['view_footerlink'],
  },
  {
    key: 'adminProject.footerBottom',
    path: `/admin/footer-bottom`,
    component: React.lazy(
      () => import('../../components/Admin/Footer-Bottom/FooterBottomList')
    ),
    authority: ['view_footerbottom'],
  },
  {
    key: 'adminProject.footerBottom',
    path: `/admin/footer-bottom/add-new`,
    component: React.lazy(
      () => import('../../components/Admin/Footer-Bottom/FooterBottomForm')
    ),
    authority: ['add_footerbottom'],
  },
  {
    key: 'adminProject.importantContacts',
    path: `/admin/footer-links/add-new`,
    component: React.lazy(
      () => import('../../components/Admin/Footer-Links/FooterLinksForm')
    ),
    authority: ['add_footerlink'],
  },
  {
    key: 'adminProject.footerBottom',
    path: `/admin/footer-bottom/edit/:id`,
    component: React.lazy(
      () => import('../../components/Admin/Footer-Bottom/FooterBottomForm')
    ),
    authority: ['change_footerlink'],
  },
  {
    key: 'adminProject.importantContacts',
    path: `/admin/footer-links/edit/:id`,
    component: React.lazy(
      () => import('../../components/Admin/Footer-Links/FooterLinksForm')
    ),
    authority: ['change_footerlink'],
  },
  {
    key: 'adminProject.footerImage',
    path: `/admin/footer/upload`,
    component: React.lazy(
      () => import('../../components/Admin/Footer-Image/FooterImageForm')
    ),
    authority: ['add_footerimage', 'change_footerimage'],
  },
  {
    key: 'adminProject.visitCard',
    path: `/admin/visit-card`,
    component: React.lazy(
      () => import('../../components/Admin/Visit-card/VisitcardList')
    ),
    authority: ['view_externalcard'],
  },
  {
    key: 'adminProject.visitCard',
    path: `/admin/visit-card/new`,
    component: React.lazy(
      () => import('../../components/Admin/Visit-card/VisitcardForm')
    ),
    authority: ['add_externalcard'],
  },
  {
    key: 'adminProject.visitCard',
    path: `/admin/visit-card/edit/:id`,
    component: React.lazy(
      () => import('../../components/Admin/Visit-card/VisitcardForm')
    ),
    authority: ['change_externalcard'],
  },
  {
    key: 'adminProject.notification',
    path: `/admin/notification-list`,
    component: React.lazy(
      () => import('../../components/Admin/Notification/NotificationList')
    ),
    authority: ['view_notificationmaster'],
  },
  {
    key: 'adminProject.notification',
    path: `/admin/notification`,
    component: React.lazy(() => import('../../components/Admin/Notification')),
    authority: ['add_notificationmaster'],
  },
  {
    key: 'adminProject.notificationAll',
    path: `/admin/notification-all`,
    component: React.lazy(
      () => import('../../components/Admin/Notification/NotificationAll')
    ),
    authority: ['add_notificationmaster'],
  },
  {
    key: 'adminProject.editNotification',
    path: `/admin/notification-list/edit/:id`,
    component: React.lazy(
      () => import('../../components/Admin/Notification/EditNotification')
    ),
    authority: ['add_notificationmaster'],
  },
  {
    key: 'adminProject.admin-notice',
    path: `/admin/notice`,
    component: React.lazy(() => import('../../components/Admin/Notice/Notice')),
    authority: ['view_headernotice'],
  },
  {
    key: 'adminProject.admin-notice',
    path: `/admin/notice/add`,
    component: React.lazy(
      () => import('../../components/Admin/Notice/NoticeForm')
    ),
    authority: ['add_headernotice'],
  },
  {
    key: 'adminProject.admin-notice',
    path: `/admin/notice/edit/:id`,
    component: React.lazy(
      () => import('../../components/Admin/Notice/NoticeForm')
    ),
    authority: ['change_headernotice'],
  },
  {
    key: 'adminProject.importantLink',
    path: `/admin/important-links`,
    component: React.lazy(
      () => import('../../components/Admin/File-upload/ImportantLinkList')
    ),
    authority: ['view_document'],
  },
  {
    key: 'adminProject.applicationSettings',
    path: `/admin/application-settings`,
    component: React.lazy(
      () =>
        import(
          '../../components/Admin/Settings/Application-settings/ApllicationSettings'
        )
    ),
    authority: ['change_appsettings'],
  },
  {
    key: 'adminProject.applicationSettings',
    path: `/admin/cache-clear`,
    component: React.lazy(
      () =>
        import(
          '../../components/Admin/Settings/Cache-clear-settings/CacheClearSettings'
        )
    ),
    authority: ['delete_cache'],
  },
  {
    key: 'adminProject.popupSettings',
    path: `/admin/popup-settings`,
    component: React.lazy(
      () =>
        import('../../components/Admin/Settings/Popup-settings/PopupSettings')
    ),
    authority: ['change_appsettings'],
  },
  {
    key: 'adminProject.feedback',
    path: `/admin/feedback-list`,
    component: React.lazy(
      () =>
        import('../../components/Admin/Feedbacks/Feedback-list/FeedbackList')
    ),
    authority: ['view_all_feedback'],
  },
  {
    key: 'adminProject.chatbot',
    path: `/admin/chatbot/message-list`,
    component: React.lazy(
      () => import('../../components/Admin/Chatbot/Message-list/MessageList')
    ),
    authority: ['view_all_feedback'],
  },
  {
    key: 'adminProject.tickets',
    path: `/admin/tickets`,
    component: React.lazy(
      () => import('../../components/Ticketing-system/Tickets/index')
    ),
    authority: ['view_ticket'],
  },

  {
    key: 'adminProject.ticketDetails',
    path: `/admin/tickets/ticket-details/:id`,
    component: React.lazy(
      () => import('../../components/Ticketing-system/Ticket-details/index')
    ),
    authority: ['view_ticket'],
  },

  {
    key: 'adminProject.hr-representative',
    path: `/admin/hr-representative`,
    component: React.lazy(
      () => import('../../components/Ticketing-system/Hr-Representative/index')
    ),
    authority: ['view_manager', 'view_managergroup'],
  },

  {
    key: 'adminProject.ticket-create',
    path: `/admin/tickets/ticket-create`,
    component: React.lazy(
      () => import('../../components/Ticketing-system/Tickets/Create/Create')
    ),
    authority: ['add_ticket'],
  },
  {
    key: 'adminProject.ticket-create',
    path: `/admin/tickets/edit/:id`,
    component: React.lazy(
      () => import('../../components/Ticketing-system/Tickets/Create/Create')
    ),
    authority: ['change_ticket'],
  },
  {
    key: 'adminProject.hr-representative',
    path: `/admin/hr-representative/new`,
    component: React.lazy(
      () =>
        import(
          '../../components/Ticketing-system/Hr-Representative/Customer-Support/Customer-Support-Member/Create/index'
        )
    ),
    authority: ['add_manager'],
  },
  {
    key: 'adminProject.hr-representative',
    path: `/admin/hr-representative/edit/:id`,
    component: React.lazy(
      () =>
        import(
          '../../components/Ticketing-system/Hr-Representative/Customer-Support/Customer-Support-Member/Create/index'
        )
    ),
    authority: ['change_manager'],
  },
  {
    key: 'adminProject.hr-representative',
    path: `/admin/hr-representative/group/new`,
    component: React.lazy(
      () =>
        import(
          '../../components/Ticketing-system/Hr-Representative/Customer-Support-Group/Create/index'
        )
    ),
    authority: ['add_managergroup'],
  },
  {
    key: 'adminProject.hr-representative',
    path: `/admin/hr-representative/group/edit/:id`,
    component: React.lazy(
      () =>
        import(
          '../../components/Ticketing-system/Hr-Representative/Customer-Support-Group/Create/index'
        )
    ),
    authority: ['change_managergroup'],
  },
  {
    key: 'adminProject.hr-representative',
    path: `/admin/hr-representative/group/view/:id`,
    component: React.lazy(
      () =>
        import(
          '../../components/Ticketing-system/Hr-Representative/Customer-Support-Group/Create/index'
        )
    ),
    authority: ['view_managergroup'],
  },
];

export default appsRoute;
